import { ActionContext } from 'vuex/types/index'

import { AuthUser, SessionState, RegisterUser, OauthUser ,ResetUser} from '~/types/api/auth'
import { Context } from '~/types/ext/vue'

export const state = (): SessionState => ({
  authUser: undefined,
  registerUser: undefined,
  oauthUser: undefined,
  resetUser: undefined,
})

export const mutations = {
  setAuthUser: (state: SessionState, user: AuthUser) => {
    state.authUser = user
  },
  setRegisterUser: (state: SessionState, user: RegisterUser) => {
    state.registerUser = user
  },
  setOauthUser: (state: SessionState, user: OauthUser) => {
    state.oauthUser = user
  },
  setResetUser: (state: SessionState, user: ResetUser) => {
    state.resetUser = user
  }
}

export const actions = {
  nuxtServerInit: (
    ctx: ActionContext<SessionState, any>,
    nuxtCtx: Context<{
      req: {
        session: SessionState
      }
    }>
  ) => {
    if (nuxtCtx.req.session && nuxtCtx.req.session.authUser) {
      // SSR時点でログイン済みの場合、SPA認証チェック用にvueのstoreにauth情報を設定する
      ctx.commit('setAuthUser', nuxtCtx.req.session.authUser)
    } else {
      // sessionに認証情報がないときは、storeの認証情報もクリアする
      ctx.commit('setAuthUser', null)
    }

    if (nuxtCtx.req.session && nuxtCtx.req.session.registerUser) {
      ctx.commit('setRegisterUser', nuxtCtx.req.session.registerUser)
    } else {
      ctx.commit('setRegisterUser', null)
    }

    if (nuxtCtx.req.session && nuxtCtx.req.session.resetUser) {
      ctx.commit('setResetUser', nuxtCtx.req.session.resetUser)
    } else {
      ctx.commit('setResetUser', null)
    }

    if (nuxtCtx.req.session && nuxtCtx.req.session.oauthUser) {
      ctx.commit('setOauthUser', nuxtCtx.req.session.oauthUser)
    } else {
      ctx.commit('setOauthUser', null)
    }
  },
}
